/**
 * @generated SignedSource<<e20f3bfab8d2f7da3bbd6e569183eff1>>
 * @relayHash 59159738ce01375d7a911dff1b5c2ed9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e99354d3d6be85fcfd5f1556df4125bdf7c62945b86eb4dbb3c4f3209720aee5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkforceOptimizationSettingsPageQuery } from './WorkforceOptimizationSettingsPageQuery.graphql';

const node: PreloadableConcreteRequest<WorkforceOptimizationSettingsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e99354d3d6be85fcfd5f1556df4125bdf7c62945b86eb4dbb3c4f3209720aee5",
    "metadata": {},
    "name": "WorkforceOptimizationSettingsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
